// import { toggleAlertPageIsVisible } from "../alertPage/alertPage.actions";
import { setInstantStep } from "../instantReq/instantReq.actions";
import preReqTypes from "./preReq.types";

export const fetchTypeOfLoadStart = () => ({
  type: preReqTypes.FETCH_TYPE_OF_LOAD_START,
});
export const fetchTypeOfLoadSuccess = (typeOfLoad) => ({
  type: preReqTypes.FETCH_TYPE_OF_LOAD_SUCCESS,
  payload: typeOfLoad,
});
export const submitPreReqAsyncStart = () => ({
  type: preReqTypes.SUBMIT_PREREQ_START,
});
export const submitPreReqAsyncSuccess = (res) => ({
  type: preReqTypes.SUBMIT_PREREQ_SUCCESS,
  payload: res,
});
export const setPreReqResponseNewInstantRequest = (res) => ({
  type: preReqTypes.RESPONSE_NEW_INSTANT_REQUEST,
  payload: res,
});
export const setResponseInstantRequestResult = (res) => ({
  type: preReqTypes.RESPONSE_NEW_INSTANT_REQUEST_RESULT,
  payload: res,
});
export const setShownSupport = (data) => ({
  type: preReqTypes.SET_SHOWN_SUPPORT,
  payload: data,
});

// async
let fetchCheckTypeOfLoadReq_counter = 0;
export const fetchCheckTypeOfLoadReqAsync =
  (socket) => (dispatch, getState) => {
    dispatch(fetchTypeOfLoadStart());
    const obj = {
      source_location: getState().newReuqest.source_location,
      destination_location: getState().newReuqest.destination_location,
      vehicle_requested: getState().newReuqest.selected_vehicle._id,
    };
    // debugger;
    socket.emit("check_type_of_load_request", obj);

    if (fetchCheckTypeOfLoadReq_counter++ !== 0) return;

    socket.on("response_check_type_of_load_request", (data) => {
      console.log("load__type", data);
      dispatch(fetchTypeOfLoadSuccess(data));
    });
  };

let submitPreReqAsync_counter = 0;
export const submitPreReqAsync = (socket) => (dispatch, getState) => {
  // alert("start");
  dispatch(submitPreReqAsyncStart());

  if (getState().preReq.typeOfLoad.type === "instant") {
    const {
      destination_location,
      selected_loadType,
      source_location,
      barnameh,
      load_value,
      selected_vehicle,
      suggestionPrice,
      shownSuggestionPrice,
      desc_load,
      is_two_way,
      receiver_info,
      payment_in_destination,
      other_destination_location,
      loading_description,
      evacuation_description,
    } = getState().newReuqest;
    const shown_support = getState().preReq.shown_support;
    const obj = {
      destination_location: {
        ...destination_location,
        destination_address_id: "",
      },
      other_destinations: other_destination_location,
      source_location: {
        ...source_location,
        source_address_id: "",
      },
      load_description: desc_load,
      load_type: selected_loadType,
      loading_description: loading_description,
      evacuation_description: evacuation_description,
      // loading_date: "",
      // loading_time: "",
      // payment_in_destination: false,
      request_barname: barnameh,
      // request_insurance: false,
      request_model: 0, //تعرفه داره یا نه بره پیشنهادگیری صفر
      request_type: "instant",
      // shown_support: "",
      shown_tariff: suggestionPrice,
      user_changed_suggested_price: shownSuggestionPrice,
      suggested_price: suggestionPrice.suggested_price,
      value: load_value,
      vehicle_requested: selected_vehicle._id,
      vehicle_requested_type: selected_vehicle.type[0]._id,
      payment_in_destination: payment_in_destination,
      is_two_way: is_two_way,
      receiver_info: receiver_info,
      shown_support: shown_support,
      insurance_guide: shown_support.insurance.description,
    };
    console.log(obj, "instant req obj");
    // debugger;
    socket.emit("new_instant_request", obj);
  }

  if (getState().preReq.typeOfLoad.type === "fast") {
    const {
      destination_location,
      other_destination_location,
      selected_loadType,
      source_location,
      barnameh,
      load_value,
      selected_vehicle,
      suggestionPrice,
      shownSuggestionPrice,
      desc_load,
      is_two_way,
      receiver_info,
      payment_in_destination,
      loading_description,
      evacuation_description,
    } = getState().newReuqest;
    const shown_support = getState().preReq.shown_support;
    const obj = {
      destination_location: {
        ...destination_location,
        destination_address_id: "",
      },
      other_destinations: other_destination_location,
      source_location: {
        ...source_location,
        source_address_id: "",
      },
      load_description: desc_load,
      loading_description: loading_description,
      evacuation_description: evacuation_description,
      load_type: selected_loadType,
      // loading_date: "",
      // loading_time: "",
      // payment_in_destination: false,
      request_barname: barnameh,
      // request_insurance: false,
      request_model: 0, //تعرفه داره یا نه بره پیشنهادگیری صفر
      request_type: "fast",
      shown_tariff: suggestionPrice,
      user_changed_suggested_price: shownSuggestionPrice,
      suggested_price: suggestionPrice.suggested_price,
      value: load_value,
      vehicle_requested: selected_vehicle._id,
      vehicle_requested_type: selected_vehicle.type[0]._id,
      payment_in_destination: payment_in_destination,
      is_two_way: is_two_way,
      receiver_info: receiver_info,
      shown_support: shown_support,
      insurance_guide: shown_support.insurance.description,
    };
    console.log(obj, "normal req obj");
    socket.emit("insert_new_fast_load", obj);
    window.location.href = `/app2/reqs`;
  }

  if (getState().preReq.typeOfLoad.type === "normal") {
    const {
      destination_location,
      other_destination_location,
      selected_loadType,
      source_location,
      barnameh,
      load_value,
      selected_vehicle,
      suggestionPrice,
      shownSuggestionPrice,
      desc_load,
      is_two_way,
      receiver_info,
      payment_in_destination,
      loading_description,
      evacuation_description,
      weight,
      sizes_length,
      sizes_width,
      sizes_height,
      postal_code,
      packaging_type,
      selected_auction,
      bargiry_date,
      takhlieh_date,
    } = getState().newReuqest;
    const shown_support = getState().preReq.shown_support;
    const obj = {
      request_type: "normal",
      vehicle_requested: selected_vehicle._id,
      vehicle_requested_type: selected_vehicle.type[0]._id,
      source_location: {
        ...source_location,
        source_address_id: "",
        postal_code: postal_code,
      },
      destination_location: {
        ...destination_location,
        destination_address_id: "",
        postal_code: postal_code,
      },
      loading_date: bargiry_date,
      loading_time: "",
      loading_description: loading_description,
      evacuation_from: takhlieh_date,
      evacuation_to: "",
      evacuation_description: evacuation_description,
      load_description: desc_load,
      value: load_value,
      weight: weight,
      weight_unit: "kg",
      length: sizes_length,
      width: sizes_width,
      height: sizes_height,
      load_type: selected_loadType,
      packaging_type: packaging_type,
      packaging_count: 0,
      suggested_price: suggestionPrice.suggested_price,
      request_barname: barnameh,
      request_insurance: true,
      auction_id: selected_auction,
      insurance_guide: shown_support.insurance.description,
      shown_tariff: suggestionPrice,
      shown_support: shown_support,
      is_two_way: is_two_way,
      payment_in_destination: payment_in_destination,
      other_destinations: other_destination_location,
      user_changed_suggested_price: shownSuggestionPrice,
      receiver_info: receiver_info,
    };
    console.log(obj, "heavy_req_obj");
    socket.emit("insert_new_load", obj);
  }

  // if (submitPreReqAsync_counter++ !== 0) return;
  socket.on("response_new_instant_request", (data) => {
    console.log("first", data);
    console.log({ nnnnnnnn: data });
    // const { message, load_id } = data;
    dispatch(setInstantStep(data.type));
    dispatch(setPreReqResponseNewInstantRequest(data));
    // dispatch(setResponseInstantRequestResult(data));
  });
};

